export const endPoints = {
  PREPAYMENT: '/v1/booking/prepayment',
  ADDITIONAL_PAYMENT: '/v1/booking/additional-payment',
  CANCEL_PAYMENT: '/v1/booking/cancel-payment',
  CANCEL_BOOKING: '/v1/booking/cancel',
  BOOKING: '/v1/booking',
  CURRENCY_SOFT: "/v1/currency",
};
